<template fluid>
    <div>
        <blockquote class="blockquote">
            <h6 class="display-1 font-weight-regular pa-4">Bem-vindo ao Portal dos Desenvolvedores SNFe!</h6>
            <h2 class="font-weight-regular pa-4" v-if="!this.teste && !this.dialog && this.totalObjetos > 0 && !this.empresaJa">
                Selecione uma empresa para ter acesso ao sistema!
            </h2>
            <v-btn outline large color="indigo" class="ma-4" @click="escolherEmpresa" v-if="(this.totalObjetos > 0) && !this.teste && !this.dialog && !this.empresaJa">Selecionar Empresa</v-btn>
        </blockquote>
        <v-container fluid>
            <v-layout row wrap v-if="this.teste || this.dialog || this.totalObjetos === 0 || this.empresaJa || this.$store.getters.getUser.usuario.empresa_atual === null" class="ml-5">

                
                 <v-flex  xs12 sm6 md6 lg3 class="mt-2 mb-2">
                    <v-card color="#fafafa" outlined ripple max-width="300" min-height="148">
                        <v-card-title>
                            <v-icon color="indigo" medium left> receipt </v-icon>
                            <span class="title font-weight-bold">Notas</span>
                        </v-card-title>
                        <v-card-text class="headline font-weight-bold ml-5">
                            {{ totais.total }} notas
                        </v-card-text>
                    </v-card>
                 </v-flex>

                 <v-flex  xs12 sm6 md6 lg3 class="mt-2 mb-2">
                    <v-card color="#fafafa" outlined ripple max-width="300" min-height="148">
                        <v-card-title>
                            <v-icon color="indigo" medium left> attach_money </v-icon>
                            <span class="title font-weight-bold">Valor Total</span>
                        </v-card-title>
                        <v-card-text class="headline font-weight-bold ml-5">
                            R$ {{ totais.valor_total }}
                        </v-card-text>
                    </v-card>
                 </v-flex>

                 <v-flex  xs12 sm6 md6 lg3 class="mt-2 mb-2">
                    <v-card color="#fafafa" outlined ripple max-width="300" min-height="148">
                        <v-card-title>
                            <v-icon color="indigo" medium left> attach_money </v-icon>
                            <span class="title font-weight-bold">Valor Produtos</span>
                        </v-card-title>
                        <v-card-text class="headline font-weight-bold ml-5">
                            R$ {{ totais.valor_produtos }}
                        </v-card-text>
                    </v-card>
                 </v-flex>

                   <v-flex  xs12 sm6 md6 lg3 class="mt-2 mb-2">
                    <v-card color="#fafafa" outlined ripple max-width="300" min-height="148">
                        <v-card-title>
                            <v-icon color="indigo" medium left> business </v-icon>
                            <span class="title font-weight-bold">Empresas</span>
                        </v-card-title>
                        <v-card-text class="headline font-weight-bold ml-5">
                            {{ empresaTotal.total }} empresas
                        </v-card-text>
                    </v-card>
                 </v-flex>

                  <v-flex xs12 sm6 md6 lg3 class="mt-2 mb-2"> 
                    <v-card color="#fafafa" outlined max-width="300">
                        <v-card-title>
                            <v-icon color="indigo" medium left> bookmark </v-icon>
                            <span class="title font-weight-bold">Token</span>
                        </v-card-title>
                        <v-card-text class="headline font-weight-bold">
                            <v-btn outline large color="indigo" class="ml-4" @click="getUsuario">Visualizar Token</v-btn>
                            <v-layout v-if="this.teste || this.totalObjetos === 0 || this.empresaJa || this.$store.getters.getUser.usuario.empresa_atual === null">
                                <v-flex xs12>
                                    <v-textarea
                                        v-if="token"
                                        no-resize
                                        class="ma-4"
                                        rows = "13"
                                        outlined
                                        readonly
                                        color="indigo"
                                        name="inputMostrar"
                                        label="Token"
                                        :value="token"
                                    ></v-textarea>
                                </v-flex>
                            </v-layout>
                        </v-card-text>
                    </v-card>
                </v-flex>
            </v-layout>
        </v-container>
        <v-dialog v-model="dialog" max-width="350" id="resposta" ref="resposta">
            <v-card>
                <v-card-title class="headline">Selecionar Empresa</v-card-title>
                <v-card-text>
                    <v-combobox
                        v-model="empresas"
                        :items="tipoEmpresas"
                        label="Empresas"
                        hide-no-data
                        hide-selected
                        item-text="nome"
                        item-value="id"
                        placeholder="Comece a digitar para procurar"
                        return-object
                        :loading="loadingEmpresas"
                        :search-input.sync="searchEmpresa"
                        :rules="obgRules"
                        required
                    >
                    </v-combobox>
                </v-card-text>
                <v-card-actions>
                <v-spacer></v-spacer>
                    <v-btn
                        color="success"
                        text
                        class="pa-3"
                        @click="salvar"
                    >
                        Salvar
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
    import {sharedService} from '../services'

    export default {
        name: "Home",
        data(){
            return{
                teste: false,
                tipoEmpresas: [],
                empresas: '',
                token: '',
                loadingEmpresas: false,
                searchEmpresa: '',
                dialog: false,
                totalObjetos: 0,
                totais: '',
                empresaTotal: '',
                empresaJa: '',
                obgRules: [
                    v => !!v || 'Este campo é obrigatório',
                ]
            }
        },
        methods:{
            getUsuario(){

                let user = this.$store.getters.getUser
                this.token = user.token;
            },
            salvar(){
                this.$store.dispatch('definirEmpresa', this.empresas)
                this.dialog = false
                this.teste = true
            },
            escolherEmpresa(){
                let self = this
                self.dialog = true;
            },
            getEmpresa () {
                let self = this 
                
                sharedService.read('Empresas').then(function (obj){
                    self.totalObjetos = obj.total_records
                    if(self.totalObjetos > 0){
                        self.dialog = true;
                    }
                })
            },
            getTotal () {
                let self = this

                sharedService.dashboard('do/dashboard', {"model": "invoice", "options": [["data_emissao", " >= ", "2019-10-01"],["status", ">=", "4"]]}).then(function (obj){
                    self.totais = obj.retorno
                })
            },
            getTotalEmpresa () {
                let self = this

                sharedService.dashboard('do/dashboard', {"model": "empresas", "options": []}).then(function (obj){
                    self.empresaTotal = obj.retorno
                })
            }
        },
        async beforeCreate() {

            let self = this 
                
            await sharedService.read('Empresas').then(function (obj){
                self.totalObjetos = obj.total_records

                if(self.$store.getters.getEmpresa !== null){
                    self.empresaJa = self.$store.getters.getEmpresa
                }

                if(self.totalObjetos > 0 && self.$store.getters.getEmpresa === null){
                    self.dialog = true;
                }
                // self.totalObjetos = 0
            })
        },
        beforeMount(){
            this.getTotal()
            this.getTotalEmpresa()
        },
        watch: {
            searchEmpresa (val) {
                let self = this

                let busca
                if(val === null || val === ''){
                    busca = 'limit=10'
                } else {
                    busca = 'filtros=[["nome_fantasia","like","'+val+'%"]]'
                }

                self.tipoEmpresas = []
                sharedService.read('Empresas?'+busca).then(function (obj){
                    self.tipoEmpresas = []
                    for (var key in obj.obj) {
                        let obje = {
                            id: obj.obj[key].id,
                            nome: obj.obj[key].nome_fantasia
                        }
                        self.tipoEmpresas.push(obje)
                    }
                })
            }
        }
    }
</script>

<style scoped>

</style>
